const APP = {
  generateKey: (pre) => `${pre}_${Date.now()}`
};

export default APP;
